module.exports = new __parcel__URL__("bird03.2ed969c9.mp3").toString();